import { render, staticRenderFns } from "./schoolGradeManagementEdit.vue?vue&type=template&id=435f1f87&scoped=true&"
import script from "./schoolGradeManagementEdit.vue?vue&type=script&lang=js&"
export * from "./schoolGradeManagementEdit.vue?vue&type=script&lang=js&"
import style0 from "./schoolGradeManagementEdit.vue?vue&type=style&index=0&id=435f1f87&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "435f1f87",
  null
  
)

export default component.exports